export default __webpack_public_path__ + "static/media/play_next_icon_bold.9bdcf52c.svg";